import { FAILURE, REQUEST, SUCCESS } from 'utils/actionTypeUtil';

import { API_URL } from 'constants/apiUrl';
import axios from 'axios';

const apiUrl = `${API_URL}/meeting_schedule`;

export const ACTION_TYPES = {
  FETCH_WEBINAR_LIST: 'webinar/FETCH_WEBINAR_LIST',
  FETCH_WEBINAR_DATE: 'webinar/FETCH_WEBINAR_DATE',
  FETCH_WEBINAR: 'webinar/FETCH_WEBINAR',
  CREATE_WEBINAR: 'webinar/CREATE_WEBINAR',
  UPDATE_WEBINAR: 'webinar/UPDATE_WEBINAR',
  DELETE_WEBINAR: 'webinar/DELETE_WEBINAR',
  RESET: 'webinar/RESET',
};

const initial = {
  loading: false,
  errorMessage: null,
  updating: false,
  updateSuccess: false,
  entities: [], //ent
  entities2: [], //ent
  entity: {}, //defaultValue
  pageable: {
    sort: {
      sorted: false,
      unsorted: true,
      empty: true,
    },
    pageSize: 10,
    pageNumber: 0,
    offset: 0,
    paged: true,
    unpaged: false,
  },
  totalElements: 0,
  last: false,
  totalPages: 0,
  sort: {},
  first: true,
  numberOfElements: 0,
  size: 0,
  number: 0,
  empty: true,
};

// REDUCER
const webinarReducer = (state = initial, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_WEBINAR_LIST):
    case REQUEST(ACTION_TYPES.FETCH_WEBINAR_DATE):
    case REQUEST(ACTION_TYPES.FETCH_WEBINAR):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_WEBINAR):
    case REQUEST(ACTION_TYPES.UPDATE_WEBINAR):
    case REQUEST(ACTION_TYPES.DELETE_WEBINAR):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_WEBINAR_LIST):
    case FAILURE(ACTION_TYPES.FETCH_WEBINAR_DATE):
    case FAILURE(ACTION_TYPES.FETCH_WEBINAR):
    case FAILURE(ACTION_TYPES.CREATE_WEBINAR):
    case FAILURE(ACTION_TYPES.UPDATE_WEBINAR):
    case FAILURE(ACTION_TYPES.DELETE_WEBINAR):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload.response,
      };
    case SUCCESS(ACTION_TYPES.FETCH_WEBINAR_LIST):
      let res = action.payload.data;
      return {
        ...state,
        loading: false,
        entities: res.content,
        pageable: {
          sort: {
            sorted: res.pageable.sort.sorted,
            unsorted: res.pageable.sort.unsorted,
            empty: res.pageable.sort.empty,
          },
          pageSize: res.pageable.page_size,
          pageNumber: res.pageable.page_number,
          offset: res.pageable.offset,
          paged: res.pageable.paged,
          unpaged: res.pageable.unpaged,
        },
        totalElements: res.total_elements,
        last: res.last,
        totalPages: res.total_pages,
        sort: res.sort,
        first: res.first,
        numberOfElements: res.number_of_elements,
        size: res.size,
        number: res.number,
        empty: res.empty,

      };
    case SUCCESS(ACTION_TYPES.FETCH_WEBINAR_DATE):
        let resdate = action.payload.data;
        return {
          ...state,
          loading: false,
          entities: resdate,  
        };
    case SUCCESS(ACTION_TYPES.FETCH_WEBINAR):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_WEBINAR):
    case SUCCESS(ACTION_TYPES.UPDATE_WEBINAR):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
        successMessage: action.payload.meta,
      };
    case SUCCESS(ACTION_TYPES.DELETE_WEBINAR):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return { ...initial };
    default:
      return state;
  }
};

export default webinarReducer;

// ACTIONS
export const getEntities = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_WEBINAR_LIST,
  payload: axios.get(apiUrl, {
    params: {
      page: undefined || page,
      size: undefined || size,
      sort: undefined || sort,
    },
  }),
});

export const getEntitiesCondition = (condition, page) => ({
  type: ACTION_TYPES.FETCH_WEBINAR_LIST,
  payload: axios.get(`${apiUrl}/search?q=${condition}`, {
    params: {
      page: undefined || page
    },
  })
});

export const getEntitiesByDate = (date) => ({
  type: ACTION_TYPES.FETCH_WEBINAR_DATE,
  payload: axios.get(`${apiUrl}/date?q=${date}`)
});

export const getEntity = id => ({
  type: ACTION_TYPES.FETCH_WEBINAR,
  payload: axios.get(`${apiUrl}/${id}`),
});

export const createEntity = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_WEBINAR,
    payload: axios.post(apiUrl, entity),
    meta: { successMessage: `Berhasil simpan!`, errorMessage:"Gagal Simpan" },
  });
  return result;
};

export const updateEntity = (entity, id) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_WEBINAR,
    payload: axios.patch(`${apiUrl}/${id}`, entity),
    meta: { successMessage: `Berhasil update!` },
  });
  return result;
};

export const deleteEntity = id => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_WEBINAR,
    payload: axios.delete(`${apiUrl}/${id}`),
    meta: { successMessage: `Berhasil hapus!` },
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
